module.exports = __webpack_public_path__ + "img/homelike.472687bf.jpg";